import { render, staticRenderFns } from "./IframeWrapper.vue?vue&type=template&id=61c17a52&scoped=true&"
import script from "./IframeWrapper.vue?vue&type=script&lang=js&"
export * from "./IframeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IframeWrapper.vue?vue&type=style&index=0&id=61c17a52&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c17a52",
  null
  
)

export default component.exports